import React from "react";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { Col, Row, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dataTable.css";

// Import Material UI components
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6B7A99", // Custom primary color
    },
    secondary: {
      main: "#f44336", // Secondary color remains the same
    },
  },
});

const DataTable = ({
  tableData,
  header,
  isPagination = true,
  onPageChange,
  currentPage,
  pageCount,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <div className="table-container">
        <DatatableWrapper
          body={tableData?.length > 0 ? tableData : []}
          headers={header}
        >
          <Table>
            <TableHeader />
            <TableBody />
          </Table>

          <Row>
            <Col
              lg={12}
              className="pagination-container"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              {isPagination && tableData?.length > 0 && (
                <Pagination
                  count={pageCount} // Total number of pages
                  page={currentPage} // Current active page
                  onChange={(event, value) => onPageChange(value)} // Handle page change
                  showFirstButton
                  showLastButton
                  shape="rounded"
                  color="primary" // Use the custom primary color
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#636E72", // Inactive buttons text color
                      "&:hover": {
                        color: "#636E72", // Keep the same color on hover
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#6B7A99", // Active button background color
                      color: "white", // Active button text color
                      "&:hover": {
                        backgroundColor: "#6B7A99", // Prevent hover effect
                      },
                      "&:focus": {
                        backgroundColor: "#6B7A99", // Prevent focus effect
                      },
                      "&:active": {
                        backgroundColor: "#6B7A99", // Prevent active effect
                      },
                    },
                  }}
                />
              )}
            </Col>
          </Row>
        </DatatableWrapper>
      </div>
    </ThemeProvider>
  );
};

export default DataTable;
